export const isDevelopment = window.location.hostname.includes('localhost')
export const getPartner = () => {
  if (isDevelopment) {
    //@ts-ignore
    return window.settings.APP_PARNER || 'owiks'
  }

  const [partner] = window.location.hostname.split('.')

  return partner
}

const partner = getPartner()
//@ts-ignore
const domain = window.settings.BASE_FORMS_DOMAIN

export const baseURL = `//${partner}.${domain}/public`
export const authURL = `//${domain}`
